// import React from "react";
// // import {
// //   Breadcrumbs as MUIBreadcrumbs,
// //   Link,
// //   Typography
// // } from "@material-ui/core";
// import { withRouter } from "react-router-dom";

// import { Link, Typography, Breadcrumbs as MUIBreadcrumbs } from "@mui/material";
// function toTitleCase(str) {
//   return str.replace(/\b\w+/g, function (s) {
//     return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
//   });
// }

// const Breadcrumbs = (props) => {
//   const {
//     history,
//     location: { pathname },
//   } = props;
//   const pathnames = pathname.split("/").filter((x) => x);
//   return (
//     <MUIBreadcrumbs aria-label="breadcrumb">
//       {pathnames.length > 0 ? (
//         // <Link
//         //   style={{ color: "rgba(0, 0, 0, 0.6)", textDecoration: "none" }}
//         //   onClick={() => history.push("/")}
//         // >
//         //   Home
//         // </Link>
//         <></>
//       ) : (
//         <Typography> Dashboard </Typography>
//       )}

//       {pathnames.map((name, index) => {
//         const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
//         const isLast = index === pathnames.length - 1;
//         return isLast ? (
//           <Typography style={{ color: "black" }} key={name}>
//             {name}
//             {toTitleCase}
//           </Typography>
//         ) : (
//           <Link
//             style={{ color: "rgba(0, 0, 0, 0.6)", textDecoration: "none" }}
//             key={name}
//             onClick={() => history.push(routeTo)}
//           >
//             {name}
//             {toTitleCase}
//           </Link>
//         );
//       })}
//     </MUIBreadcrumbs>
//   );
// };

// export default withRouter(Breadcrumbs);

import React from "react";
// import {
//   Breadcrumbs as MUIBreadcrumbs,
//   Link,
//   Typography
// } from "@material-ui/core";
import { withRouter } from "react-router-dom";

import { Link, Typography, Breadcrumbs as MUIBreadcrumbs } from "@mui/material";
function toTitleCase(str) {
  return str.replace(/\b\w+/g, function (s) {
    return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
  });
}

const Breadcrumbs = (props) => {
  const {
    history,
    location: { pathname },
  } = props;
  const pathnames = pathname.split("/").filter((x) => x);
  return (
    <MUIBreadcrumbs aria-label="breadcrumb">
      {pathnames.length > 0 ? (
        // <Link
        //   style={{ color: "rgba(0, 0, 0, 0.6)", textDecoration: "none" }}
        //   onClick={() => history.push("/")}
        // >
        //   Home
        // </Link>
        <></>
      ) : (
        <Typography
          // className="fw-bolder"
          style={{ color: "#000", fontWeight: "600", fontSize: "1rem" }}
        >
          {" "}
          Dashboard{" "}
        </Typography>
      )}

      {pathnames.map((name, index) => {
        const intVal = Number(name);

        // if (!isNaN(intVal)) {
        //   name = "";
        // }

        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        return isNaN(intVal) && isLast ? (
          <Typography
            class="text-capitalize fw-bold"
            style={{ color: "black", cursor: "pointer" }}
            key={name}
          >
            {name}
            {toTitleCase}
          </Typography>
        ) : (
          isNaN(intVal) && (
            <Link
              class="text-capitalize fw-bold"
              style={{
                color: "rgba(0, 0, 0, 0.6)",
                textDecoration: "none",
                cursor: "pointer",
                color: "black",
              }}
              key={name}
              onClick={() => history.push("/")}
            >
              {name}
              {toTitleCase}
            </Link>
          )
        );
      })}
    </MUIBreadcrumbs>
  );
};

export default withRouter(Breadcrumbs);
